import 'select2';

export function select2Init() {
  const $select = $('.form-control-select:not(.no-default-select2)');
  if (!$select && $select.length === 0) return;

  $select.each((i, el) => {
    const $t = $(el);
    const placeholder = $t.data('placeholder');
    const search = $t.data('search');
    const width = $t.data('width');
    let autoWidth = false;
    if (width && width === 'auto') autoWidth = true;

    $t.select2({
      selectionCssClass: ':all:',
      dropdownCssClass: ':all:',
      placeholder: placeholder,
      minimumResultsForSearch: search ? 1 : Infinity,
      dropdownAutoWidth: autoWidth,
    });
  });
}
